import { Box, Chip, Grid, Pagination, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useNavigate } from 'react-router-dom';
import AlphabetHeader from '../componentes/AlphabetHeader';
import mobile from '../lib/mobile';
import { limpiarTexto } from '../lib/format';

const ListadoOrganismos = ({ busqueda = '' }) => {
    const [empresas, setEmpresas] = useState([]);
    const [search, setSearch] = useState(busqueda);
    const [filteredRows, setFilteredRows] = useState([]);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    // realizar busqueda
    useEffect(() => {
        if (busqueda === '') {
            init();
        } else {
            let newEmpresas = empresas.filter((empresa) => empresa.nombre.toLowerCase().includes(busqueda.toLowerCase()) || empresa.nombre_comercial.toLowerCase().includes(busqueda.toLowerCase()));
            setFilteredRows(newEmpresas);
        }
        //setEmpresas()
    }, [busqueda]);

    const init = async () => {
        try {
            await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/organismos?page=${page}`)
                .then(res => res.json())
                .then((respuesta) => {
                    setEmpresas(respuesta.data.empresas_completas);
                    setFilteredRows(respuesta.data.empresas);
                });
        } catch (error) {
            //console.log(error);
            //alert(error);
        }
    }

    useEffect(() => {
        init();
        setIsMobile(mobile());
    }, []);
    const columns = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 250, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        {/* <Typography variant="body1" noWrap>{params.row.descripcion}</Typography> */}
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.localidad}, {empresa.municipio}, {empresa.estado}</Typography>
                        {/* <Link to={`/empresas/${empresa.nombre}`}> */}
                        <Typography sx={{ mt: 6, "& :hover": { cursor: 'pointer' } }} color="#404555">{'Detalle >'}</Typography>
                        {/* </Link> */}
                    </Box>
                )
            }
        },
        // para indicar si la empresa es una vista preliminar
        {
            headerHeight: 0,
            field: 'status',
            headerName: '',
            width: 135,
            renderCell: (params) => {
                return (
                    <Box>
                        {
                            params.row.status == 0 ?
                                <Chip label={'Vista preliminar'} color={'warning'} />
                                :
                                <></>
                        }
                    </Box>
                )
            }

        }

    ]

    const columnsSmall = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 100, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.municipio}, {empresa.estado}</Typography>
                    </Box>
                )
            }
        }
    ]
    const handleLetterClick = (filteredRows) => {
        setFilteredRows(filteredRows);
    };
    // para la paginacion
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const handleChangePage = (e, v) => setPage(v);
    useEffect(() => {
        const get = async () => {
            const url = `https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/organismos?page=${page}`;
            await fetch(url)
                .then((res) => res.json())
                .then((respuesta) => {
                    //setEmpresas(respuesta.data.empresas);
                    setFilteredRows(respuesta.data.empresas);
                    setTotalPages(respuesta.data.cant_paginas);
                });
        }
        get();
    }, [page]);
    return (
        <Box sx={{ m: 2 }}>
            {/* En celular, mostrar  un boton para ir a https://https://empresas-economiasocialysolidaria.com.mx/ */}

            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <AlphabetHeader rows={empresas} onLetterClick={handleLetterClick} />
                <DataGrid
                    rowHeight={150}
                    columns={columns}
                    rows={filteredRows}
                    onRowClick={(params) => {
                        // envair a https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/nombre-empresa
                        let t = params.row.nombre_comercial.toLowerCase()
                        t = t.split(' ').join('-')
                        let nombre = limpiarTexto(t);
                        window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                        //navigate(`/empresas/${params.row.nombre}`);
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
                <DataGrid
                    rowHeight={100}
                    columns={columnsSmall}
                    rows={filteredRows}
                    onRowClick={(params) => {
                        if (!isMobile) {

                            let t = params.row.nombre_comercial.toLowerCase()
                            t = t.split(' ').join('-')
                            let nombre = limpiarTexto(t);
                            window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                        } else {
                            navigate(`/empresas/${params.row.nombre}`);
                        }
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Pagination count={totalPages} page={page} onChange={handleChangePage} />
            </Box>
        </Box>
    )
}

export default ListadoOrganismos